import { SessionItemExercice } from "./session-item-exercice";
import { SessionItem } from "./session-item";

export interface SessionItemWrapperData {
  id?: number;
  sessionId?: number;
  type?: string;
  restTime?: number;
  comment?: string;
  nbRepeat?: number;
  ord?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  sessionItems?: SessionItem[];
  sessionItemExercises?: SessionItemExercice[];
}

export class SessionItemWrapper {
  public static readonly TYPE_BLOC: string = 'BLOC';
  public static readonly TYPE_REST: string = 'REST';
  public static readonly TYPE_COMMENT: string = 'COMMENT';

  public static getNonTranslatableFields(): string[] { return ['id', 'sessionId', 'type', 'restTime', 'comment', 'nbRepeat', 'ord', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'sessionId', 'type', 'restTime', 'comment', 'nbRepeat', 'ord', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  sessionId?: number;
  type?: string;
  restTime?: number;
  comment?: string;
  nbRepeat?: number;
  ord?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  sessionItems?: SessionItem[];
  sessionItemExercises?: SessionItemExercice[];


  public static fromAPI(data: SessionItemWrapperData): SessionItemWrapper {
    if (data.sessionItems) {
      data.sessionItems = data.sessionItems.map((item) => SessionItem.fromAPI(item));
    }
    if (data.sessionItemExercises) {
      data.sessionItemExercises = data.sessionItemExercises.map((item) => SessionItemExercice.fromAPI(item));
    }
    return new SessionItemWrapper(data);
  }

  public static fromAPIList(data: SessionItemWrapperData[]): SessionItemWrapper[] {
    return data.map((item) => SessionItemWrapper.fromAPI(item));
  }

  constructor({id, sessionId, type, restTime, comment, nbRepeat, ord, createDate, createrId, updateDate, updaterId, deleteDate, deleterId,
              sessionItems, sessionItemExercises} : SessionItemWrapperData) {
    this.id = id;
    this.sessionId = sessionId;
    this.type = type;
    this.restTime = restTime;
    this.comment = comment;
    this.nbRepeat = nbRepeat;
    this.ord = ord;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;

    this.sessionItems = sessionItems;
    this.sessionItemExercises = sessionItemExercises;
  }

  public toJson(): SessionItemWrapperData {
    return {
      id: this.id,
      sessionId: this.sessionId,
      type: this.type,
      restTime: this.restTime,
      comment: this.comment,
      nbRepeat: this.nbRepeat,
      ord: this.ord,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
